"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorTokens = void 0;
const palette_1 = require("../../palette/palette");
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const colorTransparent = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-transparent',
    fallback: 'transparent'
});
// Foreground
const colorForegroundDefaultPrimary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-primary',
    fallback: palette_1.palette.primaryColorNeutralGray['100']
});
const colorForegroundDefaultSecondary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-secondary',
    fallback: palette_1.palette.primaryColorNeutralGray['70']
});
const colorForegroundDefaultTertiary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-tertiary',
    fallback: palette_1.palette.primaryColorNeutralGray['60']
});
const colorForegroundDefaultLight = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-light',
    fallback: palette_1.palette.white['100']
});
const colorForegroundDefaultTransparent = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-transparent',
    fallback: 'transparent'
});
const colorForegroundDefaultDark = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-dark',
    fallback: palette_1.palette.primaryColorNeutralGray['100']
});
const colorForegroundDefaultInverted = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-inverted',
    fallback: palette_1.palette.white['100']
});
const colorForegroundDefaultDisabled = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-disabled',
    fallback: palette_1.palette.primaryColorNeutralGray['40']
});
const colorForegroundDefaultPlaceholder = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-default-placeholder',
    fallback: palette_1.palette.primaryColorNeutralGray['50']
});
const colorForegroundBrandDefault = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-brand-default',
    fallback: palette_1.palette.virilisGreen['60']
});
const colorForegroundBrandHover = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-brand-hover',
    fallback: palette_1.palette.virilisGreen['70']
});
const colorForegroundBrandActive = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-brand-active',
    fallback: palette_1.palette.virilisGreen['80']
});
const colorForegroundOtherAlert = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-other-alert',
    fallback: palette_1.palette.ignis['60']
});
const colorForegroundOtherSuccess = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-other-success',
    fallback: palette_1.palette.virilisGreen['60']
});
const colorForegroundOtherInformation = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-other-information',
    fallback: palette_1.palette.blue['60']
});
const colorForegroundOtherWarning = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-foreground-other-warning',
    fallback: palette_1.palette.suma['60']
});
// Background
const colorBackgroundDefaultPrimary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-primary',
    fallback: palette_1.palette.primaryColorNeutralGray['10']
});
const colorBackgroundDefaultSecondary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-secondary',
    fallback: palette_1.palette.white['100']
});
const colorBackgroundDefaultTertiary = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-tertiary',
    fallback: palette_1.palette.primaryColorNeutralGray['20']
});
const colorBackgroundDefaultHover = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-hover',
    fallback: palette_1.palette.primaryColorNeutralGray['20']
});
const colorBackgroundDefaultActive = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-active',
    fallback: palette_1.palette.primaryColorNeutralGray['30']
});
const colorBackgroundDefaultDisabled = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-disabled',
    fallback: palette_1.palette.primaryColorNeutralGray['20']
});
const colorBackgroundDefaultDropdown = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-default-dropdown',
    fallback: palette_1.palette.white['100']
});
const colorBackgroundBrandDefault = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-brand-default',
    fallback: palette_1.palette.virilisGreen['60']
});
const colorBackgroundBrandHover = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-brand-hover',
    fallback: palette_1.palette.virilisGreen['70']
});
const colorBackgroundBrandActive = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-brand-active',
    fallback: palette_1.palette.virilisGreen['80']
});
const colorBackgroundOtherAlert = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-other-alert',
    fallback: palette_1.palette.ignis['50']
});
const colorBackgroundOtherTopBar1 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-other-topBar1',
    fallback: palette_1.palette.primaryColorMineralGrey['80']
});
const colorBackgroundOtherTopBar2 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-background-other-topBar2',
    fallback: palette_1.palette.primaryColorMineralGrey['70']
});
// Stroke
const colorStrokeDefaultDefault = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-default-default',
    fallback: palette_1.palette.primaryColorNeutralGray['30']
});
const colorStrokeDefaultHover = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-default-hover',
    fallback: palette_1.palette.primaryColorNeutralGray['40']
});
const colorStrokeDefaultActive = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-default-active',
    fallback: palette_1.palette.primaryColorNeutralGray['50']
});
const colorStrokeDefaultInverted = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-default-inverted',
    fallback: palette_1.palette.primaryColorNeutralGray['70']
});
const colorStrokeDefaultDisabled = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-default-disabled',
    fallback: palette_1.palette.primaryColorNeutralGray['20']
});
const colorStrokeBrandDefault = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-brand-disabled',
    fallback: palette_1.palette.virilisGreen['60']
});
const colorStrokeBrandHover = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-brand-hover',
    fallback: palette_1.palette.virilisGreen['70']
});
const colorStrokeBrandActive = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-brand-active',
    fallback: palette_1.palette.virilisGreen['80']
});
const colorStrokeBrandFocus = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-brand-focus',
    fallback: palette_1.palette.virilisGreen['90']
});
const colorStrokeOtherAlert = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-other-alert',
    fallback: palette_1.palette.ignis['60']
});
const colorStrokeDivider1 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-divider-1',
    fallback: palette_1.palette.primaryColorNeutralGray['30']
});
const colorStrokeDivider2 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-stroke-divider-2',
    fallback: palette_1.palette.primaryColorNeutralGray['20']
});
exports.colorTokens = {
    colorTransparent,
    colorForegroundDefaultPrimary,
    colorForegroundDefaultSecondary,
    colorForegroundDefaultTertiary,
    colorForegroundDefaultLight,
    colorForegroundDefaultTransparent,
    colorForegroundDefaultDark,
    colorForegroundDefaultInverted,
    colorForegroundDefaultDisabled,
    colorForegroundDefaultPlaceholder,
    colorForegroundBrandDefault,
    colorForegroundBrandHover,
    colorForegroundBrandActive,
    colorForegroundOtherAlert,
    colorForegroundOtherSuccess,
    colorForegroundOtherInformation,
    colorForegroundOtherWarning,
    colorBackgroundDefaultPrimary,
    colorBackgroundDefaultSecondary,
    colorBackgroundDefaultTertiary,
    colorBackgroundDefaultHover,
    colorBackgroundDefaultActive,
    colorBackgroundDefaultDisabled,
    colorBackgroundDefaultDropdown,
    colorBackgroundBrandDefault,
    colorBackgroundBrandHover,
    colorBackgroundBrandActive,
    colorBackgroundOtherAlert,
    colorBackgroundOtherTopBar1,
    colorBackgroundOtherTopBar2,
    colorStrokeDefaultDefault,
    colorStrokeDefaultHover,
    colorStrokeDefaultActive,
    colorStrokeDefaultInverted,
    colorStrokeDefaultDisabled,
    colorStrokeBrandDefault,
    colorStrokeBrandHover,
    colorStrokeBrandActive,
    colorStrokeBrandFocus,
    colorStrokeOtherAlert,
    colorStrokeDivider1,
    colorStrokeDivider2
};
//# sourceMappingURL=Colors.js.map